





































































import { Component, Vue } from "vue-property-decorator";
import AuthApi from "@/services/AuthApi";
import OrganizationUsersApi from "@/services/OrganizationUsers";
import AuthModule from "@/store/auth";
import TokenUtil from "@/utils/TokenUtil";
import CTooltip from "@/components/CTooltip.vue";
import TooltipModule from "@/store/tooltip";
import logger from "@/lib/log/logger";

@Component({
  components: {
    CTooltip,
  },
})
export default class LoginForm extends Vue {
  // フォーム初期値
  private form = { password: "", email: "" };

  // ログイン状態の保持
  private isStoreLogin = false;

  // エラーモーダル表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  // 「ログイン」clickで実行
  private async submit() {
    try {
      if (this.$route.name === "MLogin") {
        await this.adminLogin();
      } else if (this.$route.name === "OLogin") {
        await this.organizationAdminLogin();
      } else {
        await this.userLogin();
      }
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // ユーザーログイン
  private async userLogin() {
    const loginRes = await AuthApi.instance.userLogin(this.form);
    if (!loginRes.data.data?.user || !loginRes.data.data?.token) {
      return;
    }
    AuthModule.commitMe(loginRes.data.data.user);
    // token,ログイン状態をset
    TokenUtil.setToken(loginRes.data.data.token, this.isStoreLogin);
    this.$router.push({ name: "UDashboard" });

    if (loginRes.data.data.user.roleId === 4) {
      // organizationUser契約期限のチェック
      await OrganizationUsersApi.instance.checkExpirationDate(loginRes.data.data.user.uuid);
    }
  }

  // 管理者ログイン
  private async adminLogin() {
    const loginRes = await AuthApi.instance.adminLogin(this.form);
    if (!loginRes.data.data?.admin || !loginRes.data.data.token) {
      return;
    }
    AuthModule.commitMe(loginRes.data.data.admin);
    TokenUtil.setToken(loginRes.data.data.token, this.isStoreLogin);
    this.$router.push({ name: "MDashboard" });
  }

  // 団体管理者ログイン
  private async organizationAdminLogin() {
    const loginRes = await AuthApi.instance.organizationAdminLogin(this.form);
    if (!loginRes.data.data?.organizationAdmin || !loginRes.data.data.token) {
      return;
    }
    AuthModule.commitMe(loginRes.data.data.organizationAdmin);
    TokenUtil.setToken(loginRes.data.data.token, this.isStoreLogin);
    this.$router.push({ name: "ODashboard" });
  }
}
